<template>
	<div v-for="row in 5" :key="`skeleton-loader-row-${row}`" class="my-2 rounded-lg">
		<div class="rounded-lg bg-light-300 dark:bg-dark-800">
			<div class="flex justify-between items-center w-full bg-dark-800 dark:bg-dark-700 p-1 rounded-t-lg">
				<div class="flex items-center">
					<UiSkeleton class="h-[24px] w-[24px] rounded-full bg-light-500 dark:bg-dark-500" />
					<UiSkeleton class="h-[16px] w-[90px] mx-1 bg-light-500 dark:bg-dark-500" />
				</div>

				<UiSkeleton class="h-6 w-6 justify-end mx-1 bg-light-500 dark:bg-dark-500" />
			</div>
			<div class="p-2 overflow-x-auto overscroll-x-auto rounded-b-lg">
				<div class="grid grid-cols-1 md:grid-cols-3 gap-3 items-center">
					<UiSkeleton
						v-for="event in 5"
						:key="`daily-skeleton-loader-${event}`"
						class="mx-1 w-full h-[42px] rounded-md bg-light-500 dark:bg-dark-500"
					>
					</UiSkeleton>
				</div>
			</div>
		</div>
	</div>
</template>
